/* src/app/pages/qpcr-result-page/qpcr-pdf-layout/qpcr-pdf-layout.component.scss */
th {
  font-weight: bold;
  background-color: #E6E8EB;
}
table {
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
}
table thead th {
  color: white;
  font-size: 8pt;
  background-color: #3b5998;
}
tr td {
  font-size: 8pt;
}
th,
td {
  border: 1px solid #ddd;
  padding: 0px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=qpcr-pdf-layout.component.css.map */
